"use strict";
"use client";
import { jsxs } from "react/jsx-runtime";
import { useCallback, useMemo, createContext, createElement } from "react";
import { ANIMATION_DURATION } from "./Modal.js";
import { useStack } from "../../hooks/useStack/useStack.js";
const ModalContext = createContext({
  setModal: () => {
  },
  removeModal: () => {
  }
});
function ModalProvider({
  children,
  initialState,
  ...defaultModalProps
}) {
  const [modals, dispatch] = useStack(
    initialState == null ? void 0 : initialState.map((modal) => ({ ...modal, open: true }))
  );
  const setModal = useCallback(
    (modal) => {
      dispatch({ type: "push", item: modal });
    },
    [dispatch]
  );
  const removeModal = useCallback(
    (modal) => {
      if (modal.onClose) {
        modal.onClose();
      }
      dispatch({
        type: "remove",
        id: modal.id,
        transition: {
          duration: ANIMATION_DURATION
        }
      });
    },
    [dispatch]
  );
  const context = useMemo(
    () => ({ setModal, removeModal }),
    [setModal, removeModal]
  );
  return /* @__PURE__ */ jsxs(ModalContext.Provider, { value: context, children: [
    children,
    modals.map((modal) => {
      const { id, component: Component, transition, ...modalProps } = modal;
      return (
        // @ts-expect-error type will either be ModalProps or NotificationProps
        /* @__PURE__ */ createElement(
          Component,
          {
            ...defaultModalProps,
            ...modalProps,
            key: id,
            open: true,
            onClose: () => removeModal(modal)
          }
        )
      );
    })
  ] });
}
export {
  ModalContext,
  ModalProvider
};
